import http from '../../Http-common';

const getAll = (id) => {
    return http.get(`/admin/exhibitionRooms?langId=${id}`);
}

const getById = (id) => {
    return http.get(`/admin/exhibitionRoom?id=${id}`);
}

const create = (data) => {
    return http.post(`/admin/exhibitionRoom`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

const update = (data) => {
    return http.post(`/admin/exhibitionRoom`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

const getSelect = () => {
    return http.get('/admin/select/exhibitionRooms');
}

const updateSeq = (data) => {
    return http.post('/admin/exhibitionRooms/updateSeq', data);
}

const getCommentatorByType = (id) => {
    return http.get(`/admin/select/commentators?langId=${id}`);
}

const deleted = (ids) => {
    return http.delete(`/admin/exhibitionRooms?ids=${ids}`);
}

const ExhibitionService = {
    getAll,
    getById,
    create,
    update,
    getSelect,
    updateSeq,
    getCommentatorByType,
    deleted,
}

export default ExhibitionService;